import FormComponent from '../utils/FormComponent';
import * as blockUtils from '../../utils/BlockUtils';
import * as api from '../../api/management-api';
import i18next from 'i18next';
import * as viewUtils from '../../utils/view-utils';
import ModalDialog from '../utils/ModalDialog';
import Form from '../utils/Form';
import TextInput from '../utils/TextInput';
import PropTypes from 'prop-types';
import React from 'react';
import * as rights from '../../model/rights';

const TEXT_KEY = 'site_management.max_allowed_devices.';

class MaxAllowedDevicesForm extends FormComponent {
  constructor(props) {
    super(props);

    this.sendForm = this.sendForm.bind(this);

    this.state = {
      maxAllowedDevices: '',
    };
  }

  initialState() {
    blockUtils.blockUI();
    api.getMaxAllowedDevicesForSite(this.props.siteId).then((response) => {
      const maxAllowedDevices = response.data.maxAllowedDevices;
      this.setState({
        maxAllowedDevices: maxAllowedDevices ? maxAllowedDevices : '',
      });
      blockUtils.unblockUI();
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  sendForm() {
    if (!rights.currentUserHasRight(rights.MAX_ALLOWED_DEVICES_ADD_PRIVILEGE)) {
      window.showAlert(i18next.t('error'), 'Your user does not have permission to perform this action');
      return;
    }

    if (this.validateAllFields('maxAllowedDevices-card-form', TEXT_KEY) === false) {
      return;
    }

    const data = {
      siteId: this.props.siteId,
      maxAllowedDevices: this.state.maxAllowedDevices,
    };

    blockUtils.blockUI();
    api.updateMaxAllowedDevicesForSite(this.props.siteId, data).then((response) => {
      blockUtils.unblockUI();
      $(`#${this.props.dialogId}`).modal('hide');
      return response;
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), error.response.data.errorMessage);
    });
  }

  render() {
    return (
      <ModalDialog
        customClass="maxAllowedDevices-card-form"
        modalTitle={i18next.t('site_management.max_allowed_devices.form_title')}
        dialogId={this.props.dialogId}
        onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow}
        onSubmit={this.sendForm}
        showSave={rights.currentUserHasRight(rights.MAX_ALLOWED_DEVICES_ADD_PRIVILEGE)}
      >

        <Form>
          <TextInput
            fieldId="maxAllowedDevices"
            labelText={i18next.t('site_management.max_allowed_devices.maxAllowedDevices')}
            onChange={this.onChange}
            value={this.state.maxAllowedDevices}
            isRequired={true}
            validate={() => this.validateField(TEXT_KEY, 'maxAllowedDevices')}
            error={this.state.maxAllowedDevicesError}
          />

        </Form>
      </ModalDialog>
    );
  }
}

MaxAllowedDevicesForm.propTypes = {
  siteId: PropTypes.number,
  dialogId: PropTypes.string,
};

export default MaxAllowedDevicesForm;
